import React, {FC} from "react"
import Input from "@irati/ui/src/FormItem/Input"
import {Region} from "@irati/types"

interface Props {
  region: Partial<Region>,
  onChange: (fieldName: string, value: string) => void
}

const RegionTermsAndConditionsUrl: FC<Props> = ({region, onChange}) => {
  return (
    <Input
      label="Terms and Conditions URL"
      name="termsAndConditionsUrls"
      type="text"
      value={region.termsAndConditionsUrl}
      includeCharCountdown={false}
      maxLength={500}
      onChange={(newValue) => onChange("termsAndConditionsUrl", newValue)} />
  )
}

export default RegionTermsAndConditionsUrl
